<template>
  <div
    :class="
      classes(
        n(),
        computedDisabled && n('--disabled'),
        computedChecked && n('--checked'),
        !computedMarginLess && n('--margin-less')
      )
    "
    role="radio"
    :aria-checked="computedChecked"
    :aria-disabled="computedDisabled"
    @click="handleClick"
  >
    <!-- 内容区域 -->
    <div :class="n('content')">
      <div :class="n('main')">
        <!-- 左侧图标 -->
        <component
          :is="icon"
          v-if="icon"
          :class="n('icon')"
        />
        <div :class="n('info')">
          <!-- 主文案 -->
          <div
            v-if="label"
            :class="n('label')"
          >
            {{ label }}
          </div>
          <!-- 描述文案 -->
          <div
            v-if="desc"
            :class="n('desc')"
          >
            {{ desc }}
          </div>
        </div>
      </div>
      <!-- 右侧图标 -->
      <OkOIcon
        v-if="computedChecked"
        :color="iconColor"
        :class="n('checked-icon')"
        aria-hidden="true"
      />
    </div>
    <!-- 分割线 -->
    <Divider :class="n('divider')" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, inject } from 'virtual-vue';
import { radioProps as props } from './radio-props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import { OkOIcon } from '@tencent/wphk-design-icons';
import { RADIO_GROUP_KEY } from './constants';
import Divider from '../divider/index';

const { name, n, classes } = createNamespace('radio');

export default defineComponent({
  name,
  components: {
    OkOIcon,
    Divider,
  },
  props,
  emits,
  setup(props, { emit }) {
    // 注入 RadioGroup 上下文
    const radioGroup = inject(RADIO_GROUP_KEY, null);

    // 计算属性：是否选中
    const computedChecked = computed(() => {
      if (radioGroup) {
        return radioGroup.value.value === props.value;
      }
      return props.checked;
    });

    // 计算属性：是否禁用
    const computedDisabled = computed(() => {
      if (radioGroup) {
        return radioGroup.disabled.value || props.disabled;
      }
      return props.disabled;
    });

    // 计算属性：是否允许取消选中
    const computedAllowUncheck = computed(() => {
      if (radioGroup) {
        return radioGroup.allowUncheck.value;
      }
      return props.allowUncheck;
    });

    // 计算属性：margin-less
    const computedMarginLess = computed(() => {
      if (radioGroup) {
        return radioGroup.marginLess.value;
      }
      return props.marginLess;
    });

    // 计算属性：图标颜色
    const iconColor = computed(() => {
      if (computedDisabled.value) {
        return '#07C16080';
      }
      return '#07C160';
    });

    // 点击处理
    const handleClick = () => {
      if (computedDisabled.value) return;

      if (radioGroup) {
        // 在 RadioGroup 中
        if (computedChecked.value && computedAllowUncheck.value) {
          radioGroup.onChange(undefined);
        } else if (!computedChecked.value) {
          radioGroup.onChange(props.value);
        }
      } else {
        // 独立使用
        if (props.checked && props.allowUncheck) {
          emit('change', undefined);
        } else if (!props.checked) {
          emit('change', props.value);
        }
      }
    };

    return {
      n,
      classes,
      computedChecked,
      computedDisabled,
      computedMarginLess,
      iconColor,
      handleClick,
    };
  },
});
</script>
